module.exports = __webpack_public_path__ + "static/media/selvBordered.013e13e3.svg";